module.exports = __webpack_public_path__ + "static/media/02_CALCINHA_LATERAL_DRAPEADA_LISA_10.837b7806.jpg";